import React from "react";
import { connect, useSelector } from "react-redux";
import { logout } from "../../actions/auth";
import { toggleSidebar } from "../../actions/core";
import { Logo } from "../../brand";
import IconBurger from "../iconComponents/IconBurger";
// import IconBurger from "../../assets/sidepanelIcons/icon_hamburger.svg";
import { useMediaQuery } from "react-responsive";
import profile0 from "../../assets/profile0.jpg";
import {Link} from "react-router-dom";

export function Navbar(props) {

    const status = useSelector(state => state.auth.status);
    const user = useSelector(state => state.auth.user);
    const isSmallTabletOrMobile = useMediaQuery({ query: '(max-width: 540px)' });
    // const isMobile = useMediaQuery({ query: '(max-width: 480px)'});

    return (
        <>
            {status === "authenticated" &&
                <nav className="nav flex-row ai-center space-btwn" id="private_nav">
                    <div className="flex-row ai-center ">
                        <button className="iblock" onClick={() => props.toggleSidebar()}>
                            <IconBurger className="sp-icon" height="21px" pathClass="g6-fill" />
                        </button>
                        {!isSmallTabletOrMobile &&
                            <>
                                <div className="iblock">
                                    <Logo height="25px" className="nav-logo" />
                                </div>
                                <span className="nav-slogan g7-text">build trust</span>
                            </>
                        }
                    </div>
                    {isSmallTabletOrMobile && <Logo height="25px" className="nav-logo" />}
                    <div className="flex-row ai-center">
                        {!isSmallTabletOrMobile &&
                            <Link to="/settings/view" className="gap-right-m flex-row ai-center">
                                <img className="gap-right-xs" src={user.user_icon_path ? user.user_icon_path : profile0} />
                                <div className="iblock g7-text" id="user_name">{user.first_name || user.last_name ? `${user.first_name} ${user.last_name}`.trim() : user.email}</div>
                            </Link>
                        }
                        <button id="logout" className="w-text" onClick={() => props.logout()}>LOGOUT</button>
                    </div>
                </nav>
            }
        </>
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { logout, toggleSidebar })(Navbar);

